// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"34fc6fe5","290":"b9bd136e","716":"d99e45a7"}[chunkId] + ".chunk.js";
};